import { ACCT_POSTAL_CODE_LOGIN_INITIATE } from '@src/app/login/weak/accountpostalcode/actions';
import { ActionsObservable, StateObservable, ofType } from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { actionCreators as weakActionCreators } from '@src/app/login/weak/actions';
import { AccountLookupTypes } from '@src/app/_global/domain/AccountLookupTypes';
import {
  WsgRequest,
  WsgRequestPayload,
} from '@src/app/_global/domain/WsgRequest';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { getLookupMagCode } from '@src/app/login/loginUtils';

export const acctPostalCodeLoginInitiate = (
  action$: ActionsObservable<RootAction>,
  state$: StateObservable<RootState>,
) =>
  action$.pipe(
    ofType(ACCT_POSTAL_CODE_LOGIN_INITIATE),
    mergeMap(({ payload: { accountNumber, postalCode, captureEmail, emailOptIn, productExcludes} }) => {
      const payload: WsgRequestPayload = {
        acctNbr: accountNumber,
        postalCode: postalCode,
        emailOptIn: emailOptIn,
        email: captureEmail,
        productExcludes: productExcludes.toString(),
      };
      var clientConfig = state$.value.clientConfig.clientConfig;
      const adminConfig = state$.value.adminConfig.adminConfig;
      const lookupMagCode = getLookupMagCode(adminConfig, clientConfig);

      var wsgPayload: WsgRequest = {
        magCode: lookupMagCode,
        globalCode: clientConfig.globalCode,
        filterType: AccountLookupTypes.accountNumberPostalCode,
        payload,
      };
      const credentials = state$.value.auth.omsAuth.credentials;
      let observable;
      if (credentials && credentials.Logins) {
        wsgPayload.idpAccountInfo = state$.value.userState.idpAccountInfo;
        observable = of(
          weakActionCreators.authIamKeysSuccess(credentials, wsgPayload),
        );
      } else {
        observable = of(weakActionCreators.unauthGetIamKeys(wsgPayload));
      }
      return observable;
    }),
  );
